import { render, staticRenderFns } from "./PolonList.vue?vue&type=template&id=63e9f942&scoped=true&"
import script from "./PolonList.vue?vue&type=script&lang=js&"
export * from "./PolonList.vue?vue&type=script&lang=js&"
import style0 from "./PolonList.vue?vue&type=style&index=0&id=63e9f942&scoped=true&lang=scss&"
import style1 from "./PolonList.vue?vue&type=style&index=1&id=63e9f942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e9f942",
  null
  
)

export default component.exports